import React, { PropsWithChildren } from "react";
import {
  View,
  ViewStyle,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
} from "react-native";
import ReactNativeModal from "react-native-modal";
import Toast from "components/toast";

import { sn } from "utils";
import { sizes, colors } from "assets/constants";
import Button from "./Button";

type ModalT = {
  visible?: boolean;
  close?: () => void;
  hideToast?: boolean;
  hideCloseBtn?: boolean;
  contentContainerStyle?: ViewStyle;
  disableCloseWithOutsideTap?: boolean;
  disableCloseWithBakButtonTap?: boolean;
};

const Modal: React.FC<PropsWithChildren<ModalT>> = ({
  close,
  visible,
  children,
  hideToast,
  hideCloseBtn,
  contentContainerStyle,
  disableCloseWithOutsideTap,
  disableCloseWithBakButtonTap,
}) => {
  return (
    <ReactNativeModal
      isVisible={visible}
      style={{ margin: 0 }}
      animationIn={"slideInUp"}
      animationOut={"slideOutDown"}
      onBackButtonPress={!disableCloseWithBakButtonTap ? close : null}
    >
      <TouchableOpacity
        activeOpacity={1}
        style={styles.cover}
        onPress={!disableCloseWithOutsideTap ? close : null}
      >
        <View style={styles.container}>
          <ScrollView
            nestedScrollEnabled
            showsVerticalScrollIndicator={false}
            keyboardShouldPersistTaps={"handled"}
            contentContainerStyle={styles.scroll}
          >
            <TouchableOpacity
              activeOpacity={1}
              style={styles.scroll}
              onPress={!disableCloseWithBakButtonTap ? close : null}
            >
              <TouchableOpacity
                activeOpacity={1}
                onPress={null}
                style={{ ...styles.contentContainer, ...contentContainerStyle }}
              >
                {!hideCloseBtn && (
                  <View
                    style={{
                      top: 0,
                      left: 0,
                      width: 45,
                      height: 45,
                      zIndex: 1000,
                      position: "absolute",
                    }}
                  >
                    <Button
                      onPress={close}
                      square={45}
                      bgColor={colors.transparent}
                      icon={{ name: "x", color: colors.danger, size: 25 }}
                    />
                  </View>
                )}
                {children}
              </TouchableOpacity>
            </TouchableOpacity>
          </ScrollView>
        </View>
      </TouchableOpacity>
      {!hideToast && <Toast.Provider />}
    </ReactNativeModal>
  );
};

export default React.memo(Modal);

const styles = StyleSheet.create({
  cover: { flex: 1, alignItems: "center" },

  container: {
    flex: 1,
    marginTop: sn(50, 50, 20, 20),
    marginBottom: sn(0, 0, 20, 20),
    width: "100%",
    maxWidth: 640,
    overflow: "hidden",
    borderRadius: sn(0, 0, sizes.radius.xl, sizes.radius.xl),
    borderTopLeftRadius: sizes.radius.xl,
    borderTopRightRadius: sizes.radius.xl,
  },

  scroll: {
    flexGrow: 1,
    maxWidth: 640,
    overflow: "hidden",
    backgroundColor: "transparent",
    borderTopLeftRadius: sizes.radius.xl,
    borderTopRightRadius: sizes.radius.xl,
    justifyContent: sn("flex-end", "flex-end", "center", "center"),
  },

  contentContainer: {
    paddingTop: 40,
    paddingBottom: 20,
    width: "100%",
    maxWidth: 640,
    paddingHorizontal: 2 * sizes.space,
    backgroundColor: colors.white,
    borderTopLeftRadius: sizes.radius.xl,
    borderTopRightRadius: sizes.radius.xl,
    alignSelf: "center",
    borderBottomLeftRadius: sn(0, 0, sizes.radius.xl, sizes.radius.xl),
    borderBottomRightRadius: sn(0, 0, sizes.radius.xl, sizes.radius.xl),
    overflow: "hidden",
  },
});
